import React from 'react';
import { infoPageStyles as styles } from './sharedStyles';
import { COLORS } from '../../constants';

const SafetyGuidelines = () => {
  return (
    <div style={styles.pageContainer}>
      <div style={styles.header}>
        <h1 style={styles.headerTitle}>Safety Guidelines</h1>
        <p style={styles.headerSubtitle}>
          Your safety is our top priority
        </p>
      </div>

      <div style={styles.contentContainer}>
        {/* Overview */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Staying Safe on Redbird Markets</h2>
          <p style={styles.text}>
            Redbird Markets is committed to providing a safe marketplace for the ISU community. 
            Follow these guidelines to ensure safe transactions.
          </p>
        </div>

        {/* Meeting Safety */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Meeting Safety</h2>
          
          <div style={styles.highlight}>
            <h3 style={styles.highlightTitle}>DO:</h3>
            <ul style={styles.list}>
              <li style={styles.listItem}>Meet in public, well-lit locations - examples include campus commons, student centers, or libraries</li>
              <li style={styles.listItem}>Meet during daylight hours when possible</li>
              <li style={styles.listItem}>Bring a friend or let someone know where you're going</li>
              <li style={styles.listItem}>Choose busy, populated areas with security cameras if available</li>
              <li style={styles.listItem}>Trust your instincts - if something feels off, cancel the meeting</li>
            </ul>
            <p style={{...styles.text, fontSize: '14px', marginTop: '12px', fontStyle: 'italic'}}>
              Note: RedBird Markets is not affiliated with ISU and assumes no responsibility for the safety of any locations.
            </p>
          </div>

          <div style={{...styles.highlight, background: `${COLORS.primary}08`, borderColor: '#d61c2e'}}>
            <h3 style={{...styles.highlightTitle, color: '#d61c2e'}}>DON'T:</h3>
            <ul style={styles.list}>
              <li style={styles.listItem}>Meet in isolated or private locations</li>
              <li style={styles.listItem}>Go to someone's residence alone</li>
              <li style={styles.listItem}>Meet late at night in deserted areas</li>
              <li style={styles.listItem}>Share personal information beyond what's necessary</li>
              <li style={styles.listItem}>Feel pressured to complete a transaction</li>
            </ul>
          </div>
        </div>

        {/* Transaction Safety */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Transaction Safety</h2>
          
          <h3 style={styles.subsectionTitle}>Before Meeting</h3>
          <ul style={styles.list}>
            <li style={styles.listItem}>Communicate through the Redbird Markets messaging system</li>
            <li style={styles.listItem}>Ask detailed questions about the item</li>
          </ul>

          <h3 style={styles.subsectionTitle}>During the Transaction</h3>
          <ul style={styles.list}>
            <li style={styles.listItem}>Thoroughly inspect items before paying</li>
            <li style={styles.listItem}>Test electronic items if possible</li>
            <li style={styles.listItem}>Verify authenticity of high-value items</li>
            <li style={styles.listItem}>Use secure payment methods</li>
            <li style={styles.listItem}>Get a receipt or transaction confirmation</li>
          </ul>
        </div>

        {/* Online Safety */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Online Safety</h2>
          
          <ul style={styles.list}>
            <li style={styles.listItem}><strong>Protect Personal Information:</strong> Never share your phone number, home address, or financial details publicly</li>
            <li style={styles.listItem}><strong>Use Platform Messaging:</strong> Keep all communications within Redbird Markets</li>
            <li style={styles.listItem}><strong>Beware of Scams:</strong> Be suspicious of deals that seem too good to be true</li>
            <li style={styles.listItem}><strong>Verify Identity:</strong> Only transact with verified ISU community members</li>
            <li style={styles.listItem}><strong>Report Suspicious Activity:</strong> Contact us immediately if something seems wrong</li>
          </ul>
        </div>

        {/* Payment Safety */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Payment Safety</h2>
          
          <h3 style={styles.subsectionTitle}>Recommended Payment Methods</h3>
          <ul style={styles.list}>
            <li style={styles.listItem}><strong>Redbird Markets Secure Checkout:</strong> Our integrated Stripe payment system</li>
          </ul>

          <h3 style={styles.subsectionTitle}>Avoid These Payment Methods</h3>
          <ul style={styles.list}>
            <li style={styles.listItem}>Wire transfers or money orders</li>
            <li style={styles.listItem}>Payment apps to strangers (outside the platform)</li>
            <li style={styles.listItem}>Cryptocurrency or gift cards</li>
            <li style={styles.listItem}>Checks from unknown parties</li>
            <li style={styles.listItem}>Any payment method that can't be verified or reversed</li>
          </ul>
        </div>

        {/* Red Flags */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Red Flags to Watch For</h2>
          
          <div style={styles.highlight}>
            <h3 style={styles.highlightTitle}>Warning Signs:</h3>
            <ul style={styles.list}>
              <li style={styles.listItem}>Seller/buyer refuses to meet in public places</li>
              <li style={styles.listItem}>Requesting payment before meeting or viewing the item</li>
              <li style={styles.listItem}>Pressure to complete transaction quickly</li>
              <li style={styles.listItem}>Unusual payment methods requested</li>
              <li style={styles.listItem}>Poor communication or evasive answers</li>
              <li style={styles.listItem}>Prices significantly below market value</li>
              <li style={styles.listItem}>Seller can't provide more information</li>
            </ul>
          </div>
        </div>

        {/* Emergency Contact */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Emergency & Reporting</h2>
          
          <div style={styles.highlight}>
            <h3 style={styles.highlightTitle}>If You Feel Unsafe</h3>
            <ul style={styles.list}>
              <li style={styles.listItem}><strong>ISU Police:</strong> (309) 438-8631 (Emergency: 911)</li>
              <li style={styles.listItem}><strong>Document Everything:</strong> Keep screenshots of conversations</li>
            </ul>
          </div>

          <p style={styles.text}>
            Remember: Your safety is more important than any transaction. If something doesn't feel right, 
            trust your instincts and walk away.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SafetyGuidelines;
